import {
    SkyNetTableTab,
} from 'app/shared-components/SkyNetTable/types/skyNetTable.types'
import {
    BaseLeaseCategory,
    ContractCurrency,
    ProductType,
} from 'app/enums/label.enums'
import {
    RateCardsTabs,
} from 'app/enums/domain.enums'
import requests from 'app/requests/RateCard/RateCard.requests'

import {
    StandardBaseLeaseFilterRequestResponse,
} from 'app/requests/RateCard/RateCard.types'

const config: SkyNetTableTab<keyof StandardBaseLeaseFilterRequestResponse> = {
    name: 'Standard Base Lease',
    url: RateCardsTabs.BaseLease,
    customUrl: requests.baseLeaseFilterRequest().url,
    defaultTab: true,
    fields: [
        {
            name: 'baseLeaseCategory',
            componentName: 'EnumValue',
            allowedValuesEnum: BaseLeaseCategory,
            labelKey: 'BASE_LEASE_CATEGORY',
        },
        {
            name: 'productType',
            componentName: 'EnumValue',
            allowedValuesEnum: ProductType,
            labelKey: 'PRODUCT_TYPE',
        },
        {
            name: 'currency',
            componentName: 'EnumValue',
            allowedValuesEnum: ContractCurrency,
            labelKey: 'CURRENCY',
        },
        {
            name: 'baseFeeValue',
            alignTextRight: true,
            labelKey: 'UP_TO_5_DAYS',
        },
        {
            name: 'additionalPeriodOne',
            alignTextRight: true,
            labelKey: 'DAY_6_TO_10',
        },
        {
            name: 'additionalPeriodTwo',
            alignTextRight: true,
            labelKey: 'DAY_11_TO_15',
        },
        {
            name: 'additionalPeriodThree',
            alignTextRight: true,
            labelKey: 'DAY_16_AND_MORE',
        },
    ],
}

export default config
